import { useContext, useCallback, useState } from "react";
import fp from "lodash/fp";
import moment from "moment";
import { useFormContext } from "react-hook-form";

import FiltersContext from "../filtersContext";

const useValidateMinMaxAge = ({ column }) => {
	const { setIsApplyDisabled } = useContext(FiltersContext);
	const { watch } = useFormContext();

	const { name, minSection, maxSection } = column;

	const daysMin = watch(`${name}.${minSection?.days?.name}`) || 0;
	const hoursMin = watch(`${name}.${minSection?.hours?.name}`) || 0;
	const minutesMin = watch(`${name}.${minSection?.minutes?.name}`) || 0;

	const dayMax = watch(`${name}.${maxSection?.days?.name}`) || 0;
	const hoursMax = watch(`${name}.${maxSection?.hours?.name}`) || 0;
	const minutesMax = watch(`${name}.${maxSection?.minutes?.name}`) || 0;

	const [isInvalid, setIsInvalid] = useState(false);

	const handleBlur = useCallback(() => {
		const durationAgeMin = moment(Date.now())
			.subtract({
				days: parseInt(daysMin),
				hours: parseInt(hoursMin),
				minutes: parseInt(minutesMin),
			})
			.format();

		const durationAgeMax = moment(Date.now())
			.subtract({
				days: parseInt(dayMax),
				hours: parseInt(hoursMax),
				minutes: parseInt(minutesMax),
			})
			.format();

		const isEmptyAgeMinValues =
			fp.isEmpty(daysMin) &&
			fp.isEmpty(hoursMin) &&
			fp.isEmpty(minutesMin);

		const isEmptyAgeMaxValues =
			fp.isEmpty(dayMax) &&
			fp.isEmpty(hoursMax) &&
			fp.isEmpty(minutesMax);

		if (isEmptyAgeMinValues || isEmptyAgeMaxValues) {
			return;
		}

		const dMin = Date.parse(durationAgeMin);
		const dMax = Date.parse(durationAgeMax);

		const isInvalid = dMin < dMax;

		setIsApplyDisabled?.(isInvalid);
		setIsInvalid(isInvalid);
	}, [
		daysMin,
		hoursMin,
		minutesMin,
		dayMax,
		hoursMax,
		minutesMax,
		setIsApplyDisabled,
		setIsInvalid,
	]);

	return { isInvalid, handleBlur };
};

export default useValidateMinMaxAge;
